module.exports = __webpack_public_path__ + "static/media/carta_90.179e7ed5.jpg";